import React, {useEffect, useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import {api} from "@/lib/api";
import {Card} from "@/components/ui/card";

export default function RewardsPreferences() {
    const {t} = useTranslation();
    const [record, setRecord] = useState(null), [busy, setBusy] = useState(false), [error, setError] = useState(false);
    const retry = useRef(null);
    useEffect(() => { api.get("/rewards/notification-preferences").then(r => setRecord(r.data)).catch(() => setError(true)); }, []);
    async function toggle(key) {
        if (busy) return;
        const preferences = {...record.state, [key]: !record.state[key]};
        const signature = JSON.stringify([record.version, preferences]);
        const request_id = retry.current?.signature === signature ? retry.current.request_id : crypto.randomUUID();
        retry.current = {signature, request_id};
        setBusy(true); setError(false);
        try { const r = await api.put("/rewards/notification-preferences", {request_id, expected_version: record.version,
            reason: "Account notification preference", preferences}); setRecord(r.data); retry.current = null; }
        catch { setError(true); } finally { setBusy(false); }
    }
    return <Card className="space-y-3 p-4"><h2 className="font-semibold">{t("rewards.notification_preferences")}</h2>
        {error && <p role="alert">{t("rewards.error")}</p>}
        <div className="flex flex-wrap gap-4">{record && Object.entries(record.state).map(([key, checked]) =>
            <label key={key} className="flex min-h-10 items-center gap-2"><input type="checkbox" checked={checked} disabled={busy} onChange={() => toggle(key)} />{t(`rewards.notification_types.${key}`)}</label>)}</div>
    </Card>;
}
